module.exports = __webpack_public_path__ + "img/18_newModelWorker_yh.66e5d8ad.png";